// extracted by mini-css-extract-plugin
export var section = "_1f-1";
export var topNav = "_1f-0";